import React, { useEffect, useState } from "react";
import EmailScreen from "./LoginForm/EmailScreen";
import PasswordScreen from "./LoginForm/PasswordScreen";
import { adminApi } from "@/store/rtk-api/admin.api";
import { useSignOut } from "@/hooks/useSignOut";

const AuthFlow = () => {
  const [email, setEmail] = useState("");
  const [isAdmin, setIsAdmin] = useState<boolean | undefined>(false);
  const [hasLoggedIn, setHasLoggedIn] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const signOut = useSignOut();

  const [trigger] = adminApi.endpoints.checkIsAdmin.useLazyQuery();
  const [triggerLogin] = adminApi.endpoints.checkIsAdminLogin.useLazyQuery();

  useEffect(() => {
    const fetchData = async () => {
      if (email) {
        try {
          const { data: adminStatus } = await trigger({ email });
          setIsAdmin(adminStatus?.isExist);

          if (adminStatus?.isExist === true) {
            const { data: adminIsLogin } = await triggerLogin({ email });
            if (adminIsLogin) {
              setHasLoggedIn(adminIsLogin.isAdmin);
            }
          } else {
            setErrorMessage(
              "This email is not registered as an administrator."
            );
            signOut();
          }
        } catch (error) {
          console.error("Error checking email:", error);
          setErrorMessage("An error occurred while checking the email.");
        }
      }
    };

    fetchData();
  }, [email, signOut, trigger, triggerLogin]);

  const handleNext = (inputEmail: string) => {
    setEmail(inputEmail);
    setErrorMessage("");
  };

  return (
    <>
      {!isAdmin ? (
        <EmailScreen onNext={handleNext} errorMessage={errorMessage} />
      ) : (
        <PasswordScreen email={email} hasLoggedIn={hasLoggedIn} />
      )}
    </>
  );
};

export default AuthFlow;
